import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

import useTextareaComponent from "~/operatorApplication/vue/dialogs/dialog/textarea/useTextareaComponent";
import {__} from "~/ts/library/Translate";
import {TAB_TYPE_FORM, TAB_TYPE_HTML, TAB_TYPE_PAYMENT} from "~/chat/ts/data/ITab";
import {AbstractApiResult} from "~/core-ui/ts/request/AbstractApiResult";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import {ref} from "vue";
import OperatorApplicationDialogTextareaButton
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationDialogTextareaButton.vue";
import OperatorApplicationSendTabDialog
    from "~/operatorApplication/vue/dialogs/dialog/OperatorApplicationSendTabDialog.vue";


import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "SendTabButton"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    tabTypeId: {},
    tooltip: {},
    icon: {}
  },
  setup(__props: any) {

let props = __props;

let {site, client, showFreeDialogForSite} = useTextareaComponent();

let sendTabDialog = ref<{
    visible: boolean,
    tabTypeId: string,
    tabs: OperatorApplicationApi.OperatorGetParamsSiteTabOpenApiModel[]
}>();

function showSendTabDialog() {
    let tabTypeId = props.tabTypeId;
    if (!showFreeDialogForSite()) {
        let tabs = getAvailableTabsByType(tabTypeId);
        if (tabs.length) {
            sendTabDialog.value = {
                visible: true,
                tabTypeId,
                tabs
            }
        } else {
            let descr = __("В настройках сайта отсутствуют вкладки этого типа");
            if (tabTypeId === TAB_TYPE_PAYMENT) {
                descr = __("В настройках сайта отсутствуют формы оплаты");
            } else if (tabTypeId === TAB_TYPE_FORM) {
                descr = __("В настройках сайта отсутствуют формы сбора данных");
            } else if (tabTypeId === TAB_TYPE_HTML) {
                descr = __("В настройках сайта отсутствуют информационные вкладки");
            }
            AbstractApiResult.showError(descr);
        }
    }
}

function getAvailableTabsByType(tabTypeId: string): OperatorApplicationApi.OperatorGetParamsSiteTabOpenApiModel[] {
    let site = OperatorAccountStore.sitesDictionary.value[client.value.siteId];
    if (site) {
        return site.tabs.filter(tab => tab.typeId == tabTypeId);
    } else {
        return [];
    }
}

function isShowSendTabDialogAvailable(tabTypeId: string): boolean {
    let tabs = getAvailableTabsByType(tabTypeId);
    return tabs.length > 0;
}



return (_ctx: any,_cache: any) => {
  return (isShowSendTabDialogAvailable(_unref(props).tabTypeId))
    ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
        _createVNode(OperatorApplicationDialogTextareaButton, {
          icon: __props.icon,
          tooltip: __props.tooltip,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showSendTabDialog()))
        }, null, 8, ["icon", "tooltip"]),
        (_unref(sendTabDialog) && _unref(sendTabDialog).visible)
          ? (_openBlock(), _createBlock(OperatorApplicationSendTabDialog, {
              key: 0,
              visible: _unref(sendTabDialog).visible,
              "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_unref(sendTabDialog).visible) = $event)),
              "tab-type-id": _unref(sendTabDialog).tabTypeId,
              tabs: _unref(sendTabDialog).tabs,
              client: _unref(client)
            }, null, 8, ["visible", "tab-type-id", "tabs", "client"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})